import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';

export interface ILoadingButtonUIStateProps {
    buttonText: string;
    sendingText?: string;
    disabled: boolean;
    isPending: boolean;
    additionalClassParams?: string;
    id?: string;
    isSubmit?: boolean;
}

export interface ILoadingButtonUIDispatchProps {
    onClick?: { () };
}

export interface ILoadingButtonUIProps extends ILoadingButtonUIStateProps, ILoadingButtonUIDispatchProps {
}

export interface ILoadingButtonUIState {
}

export default class LoadingButtonUI extends Component<ILoadingButtonUIProps, ILoadingButtonUIState> {
    static propTypes = {
        validateOnClick(props, propName, componentName) {
            if ((props['isSubmit'] !== true) && props['onClick'] === undefined) {
                return new Error(
                    'Please provide a onClick function when isSubmit is not true'
                );
            }
        }
    };

    handleClick() {
        if (this.props.onClick) {
            this.props.onClick();
        }
    }

    render() {

        const loadingText = this.props.sendingText || 'Sending';
        const continueButtonLoadingIcon = (
            <div className="dr-ui-loading-button-group">
                <span className="dr-ui-loading-button-form-submiting-indicator-text">{loadingText}</span>
                <div className="dr-ui-loading-button-spinner"></div>
            </div>);
        const buttonType = this.props.isSubmit ? 'submit' : 'button';
        const id = this.props.id ? this.props.id : 'dr-ui-loading-button';


        return (
            <button
                    disabled={this.props.disabled || this.props.isPending}
                    className={`btn btn-primary ${this.props.additionalClassParams}`}
                    id={id}
                    type={buttonType}
                    onClick={() => { this.handleClick(); }} >
                    {this.props.isPending ? continueButtonLoadingIcon :this.props.buttonText}
            </button>
        );
    }
}
